import { useTranslation } from 'react-i18next';
import { VTCart, VTCartForm, VTCartSummary } from 'vt-components'
import {Link, ScrollRestoration} from "react-router-dom";
import SEO from "components/SEO/SEO";

//CSS
import styles from "./cart.module.less"

export default function Cart() {

  const [t,i18n] = useTranslation("home","global");

  const vtconfig={
    locale:i18n.language,
    merchantURL:process.env.REACT_APP_MERCHANTURL,
    debug:process.env.REACT_APP_DEBUG
  }

  return(
    <>
      <SEO title={"Carrito"} description={"Carrito descripcion"} name='Viajes Teide' type='excursion' />

      <div className={styles.cart}>

        <div className={styles.info}>
          <VTCart config={vtconfig}/>
        </div>

        <div className={styles.form}>
          <VTCartForm config={vtconfig}/>
        </div>

        <div className={styles.sidebar}>
          <VTCartSummary config={vtconfig}/>

          <div className={styles.keepbuying}> <Link to={"/"}>{t('SEGUIR COMPRANDO')}</Link></div>
        </div>

      </div>
      <ScrollRestoration />
    </>
  )
}

